import { render } from "./Breadcrumbs.vue?vue&type=template&id=bd036f78&scoped=true"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"

import "./Breadcrumbs.vue?vue&type=style&index=0&id=bd036f78&lang=scss&scoped=true"

import exportComponent from "/Users/richardpitul/Projects/endless-projects/blue-jays-ticketfinder/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd036f78"]])

export default __exports__